import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { Textarea } from "@/components/ui/textarea";
import { preconApi } from "../lib/api";
import PersonChip from "./PersonChip";

const TRAIL = /@([A-Za-z][\w.'-]*)$/;

/** Note composer with @name suggestions from the user roster; a pick inserts @email. */
const MentionTextarea = forwardRef(function MentionTextarea({ value, onChange, onSubmit, testid = "note-composer", ...rest }, outer) {
  const [sugg, setSugg] = useState([]);
  const ref = useRef(null);
  useImperativeHandle(outer, () => ref.current);
  const change = async (v) => {
    onChange(v);
    const m = TRAIL.exec(v.slice(0, ref.current?.selectionStart ?? v.length));
    if (m) { try { setSugg(await preconApi.mentionUsers(m[1])); } catch { setSugg([]); } } else setSugg([]);
  };
  const pick = (u) => { onChange(value.replace(TRAIL, `@${u.email} `)); setSugg([]); ref.current?.focus(); };
  return (
    <div className="relative">
      <Textarea ref={ref} value={value} onChange={(e) => change(e.target.value)} data-testid={testid}
                onKeyDown={(e) => {
                  // Enter posts (or picks the first @suggestion); Shift+Enter starts a new line.
                  if (e.key !== "Enter" || e.shiftKey || e.nativeEvent.isComposing) return;
                  e.preventDefault();
                  if (sugg.length) pick(sugg[0]); else onSubmit?.();
                }} {...rest} />
      {sugg.length > 0 && (
        <ul className="absolute left-0 top-full z-20 mt-1 w-72 rounded border border-border bg-card shadow" data-testid="mention-suggestions">
          {sugg.map((u) => (
            <li key={u.email}>
              <button type="button" onClick={() => pick(u)} data-testid={`mention-pick-${u.email}`}
                      className="flex w-full items-center gap-2 px-2 py-1 text-left text-xs hover:bg-muted">
                <PersonChip name={u.name} />{u.name} <span className="text-muted-foreground">{u.email}</span>
              </button>
            </li>))}
        </ul>)}
    </div>
  );
});

export default MentionTextarea;
